import Header from './header';

export default {
  name: 'globalHeader',
  class: Header,
  querySelector: {
    target: '.nav-header--mobile',
    controller: '.site-header__mobile-menu',
  },
  querySelectorAll: {},
  options: {},
};
